import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../component/loader'
import MainLayout from '../mainLayout'
import TextField from '../component/TextField'

import CopyIcon from '../icons/copyicon'
import UploadFile from '../component/UploadFile'
import FpgMinusIcon from '../icons/fpgminusicon'
import FpgPlusIcon from '../icons/fpgplusicon'
import TextEditor from '../component/TextEditor'
import SearchIcon from '../icons/searchicon'
import serachIcon from './../assets/images/search.svg'
import HighlightTable from '../component/HighlightTable'
import FpgeeditIcon from '../icons/fpgediticon'
import FpgpublishIcon from '../icons/fpgpublishicon'
import FpgDeleteIcon from '../icons/fpgdeleteicon'
import SocialShareIcon from '../icons/SocialShareIcon'
import FpgDisableIcon from '../icons/fpgdisableicon'
import Dropdown from '../component/Dropdown'
import Textarea from '../component/Textarea'

export default class HighlightsTag extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            activetab:0,
            imagePreloader:true,
            options:["Stories","New","Highlights"],
            isEdit:false,
            data:[
                {
                    "label":"manage Highlights",
                    "Content":"",
                },
                {
                    "label":"featured highlights",
                    "Content":"",
                },
            ]
        }
    }
    TabClick = (index) => {
        this.setState({
            activetab:index
        })
    }

    EditFeatured = () =>{
        this.setState({
            isEdit:true,
        })
    }
    
    render() {
        return (
            <React.Fragment>
                <MainLayout history={this.props.history}>
                    <div className="right_side_wrapper artistView_wrapper">
                        <ul className="fpg_admin_tab disp_flex">
                            {
                                this.state.data && this.state.data.map((list,index) => {
                                    return(
                                        <li className={this.state.activetab === index ? 'active' : '' } onClick={() => this.TabClick(index)}>
                                            <p className = "uppercase text_center">
                                                {list.label}
                                            </p>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <p></p>
                            <p className="update_date">Last Update: 7:45 PM PT - 11/23/2020</p>
                        </div>
                        <div className="ticketing_content  home_content">
                            {
                                this.state.activetab === 0 ?
                                    <div className="ticketing_wrapper fpg_tabcontent">
                                        <form>
                                            <div className="d_flex">
                                                <div className="header_col">
                                                    <div className="field_row horizontal_field">
                                                            <TextField type="text" label="Header Title" />
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <Textarea label="Header Subtitle"  type="textarea" height="105px" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text_center field_row w_100 buttons_outer mb_0">
                                                <button className="uppercase">CANCEL</button>
                                                {/* <button className="uppercase prev_btn">PREviEW</button> */}
                                                <button className="uppercase active" type="button">SAVE</button>
                                            </div>
                                        </form>
                                    </div>
                                : ''
                            }
                             {
                                this.state.activetab === 1 ?
                                <>
                                    <div className="fpg_tabcontent">
                                        {
                                            this.state.isEdit ?
                                            <div className="edit_featured">
                                                    <div className="featured_container">
                                                        <form>
                                                           <div className="field_row horizontal_field">
                                                                <div className="field_row_inner">
                                                                    <label>&nbsp;</label>
                                                                    <div className="news_date field_input d_flex d_flex_align_center mb_10 mt_15">
                                                                        <strong>#Sundance</strong>
                                                                        <span>Posted on</span>
                                                                        <p>01/27/2021 - 7:00 PM</p>
                                                                    </div>
                                                                </div>
                                                           </div>
                                                            
                                                            <div className="field_row horizontal_field">
                                                                {/* <TextField type="text" label="#Sundance Social Post URL"/> */}
                                                                <div className="field_row_inner">
                                                                   <label>#Sundance Social Post URL</label>
                                                                    <div className="field_input relative">
                                                                        <input type="text" name="socialurl"/>
                                                                        <span className="error">asdasdasd sa dsfds fdsf d</span>
                                                                    </div>
                                                                    <span className="share_link pointer"><SocialShareIcon /></span>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="text_center field_row w_100 buttons_outer mb_0">
                                                                <button className="uppercase">CANCEL</button>
                                                                {/* <button className="uppercase prev_btn">PREviEW</button> */}
                                                                <button className="uppercase active" type="button">SAVE</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                        
                                            :

                                            <div className="view_featured">
                                                <div className="page_bg">
                                                    <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_center">
                                                        <Link onClick={this.EditFeatured} className="d_flex d_flex_align_center d_flex_justify_center"><FpgeeditIcon />EDIT</Link>
                                                        <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgDisableIcon /> DISABLE</Link>
                                                        <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgpublishIcon /> PUBLISH</Link>
                                                        <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgDeleteIcon />DELETE</Link>
                                                    </div>
                                                    <div className="feature_view">
                                                        <div className="news_date d_flex d_flex_align_center mb_10 mt_15">
                                                            <label>News</label>
                                                            <span>Posted on</span>
                                                            <p>01/27/2021 - 7:00 PM</p>
                                                        </div>
                                                        <div className="press_logos">
                                                            <img src="./user.png" />
                                                        </div>
                                                        <h3 className="mb_15 feature_title">Lorem ipsum dolor sit amet con sect etuer</h3>
                                                        <div className="highlight_content">
                                                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor.</p>
                                                            <Link>Link: https://hollywoodreporter.com/article12 </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                   
                                </>
                                :
                                
                                ""
                            }
                        </div>
                        
                       
                    </div>
                </MainLayout>
            </React.Fragment>
        )
    }
}
